"use client";

import { c as _c } from "react/compiler-runtime";
import { publicEnv } from "@/config/env";
import { faCopy, faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ShareIcon } from "@heroicons/react/24/outline";
import yaml from "js-yaml";
import Image from "next/image";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import useCapacitor from "@/hooks/useCapacitor";
import { DeepLinkScope } from "@/hooks/useDeepLinkNavigation";
import { useElectron } from "@/hooks/useElectron";
import { getRefreshToken, getWalletAddress, getWalletRole } from "@/services/auth/auth.utils";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import styles from "./HeaderShare.module.scss";
import { ShareMobileApp } from "./HeaderShareMobileApps";
const QRCode = require("qrcode");
enum Mode {
  NAVIGATE,
  SHARE,
  APPS,
}
enum SubMode {
  BROWSER,
  APP,
  CORE,
}
const squareStyle = {
  width: "100%",
  maxWidth: "1000px",
  aspectRatio: "1 / 1",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
export default function HeaderShare(t0) {
  const $ = _c(18);
  const {
    isCollapsed: t1
  } = t0;
  const isCollapsed = t1 === undefined ? false : t1;
  const capacitor = useCapacitor();
  const isMobileDevice = useIsMobileDevice();
  const [showQRModal, setShowQRModal] = useState(false);
  if (capacitor.isCapacitor || isMobileDevice) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <></>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShowQRModal(true);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `tw-block tw-h-[2.875rem] tw-w-full tw-cursor-pointer tw-rounded-xl tw-border-none tw-bg-transparent tw-px-2 tw-text-left tw-text-base tw-font-medium tw-text-iron-400 tw-no-underline tw-transition-colors tw-duration-200 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-iron-500 focus-visible:tw-ring-offset-2 ${isCollapsed ? "desktop-hover:hover:tw-text-white" : "desktop-hover:hover:tw-bg-iron-900 desktop-hover:hover:tw-text-white"} active:tw-bg-transparent`;
  const t4 = !isCollapsed;
  const t5 = `tw-flex tw-h-full tw-w-full tw-items-center ${isCollapsed ? "" : "tw-gap-x-2"}`;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-flex tw-w-10 tw-flex-shrink-0 tw-items-center tw-justify-center"><ShareIcon className="tw-h-6 tw-w-6 tw-flex-shrink-0" /></div>;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const t7 = `tw-block tw-overflow-hidden tw-whitespace-nowrap tw-transition-all tw-duration-300 ${isCollapsed ? "tw-w-0 tw-opacity-0" : "tw-flex-1 tw-opacity-100"}`;
  let t8;
  if ($[3] !== t7) {
    t8 = <span className={t7}>Share</span>;
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t5 || $[6] !== t8) {
    t9 = <div className={t5}>{t6}{t8}</div>;
    $[5] = t5;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t9) {
    t10 = <button type="button" aria-label="QR Code" title="QR Code" onClick={t2} className={t3} data-tooltip-id="sidebar-tooltip" data-tooltip-content="Share" data-tooltip-hidden={t4}>{t9}</button>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setShowQRModal(false);
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== showQRModal) {
    t12 = <HeaderQRModal show={showQRModal} onClose={t11} />;
    $[13] = showQRModal;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t12) {
    t13 = <div className="tailwind-scope tw-relative tw-px-3">{t10}{t12}</div>;
    $[15] = t10;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  return t13;
}
export function HeaderQRModal(t0) {
  const $ = _c(40);
  const {
    show,
    onClose
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isMobile = useIsMobileDevice();
  const {
    isAuthenticated
  } = useSeizeConnectContext();
  const [activeTab, setActiveTab] = useState(isAuthenticated ? Mode.SHARE : Mode.NAVIGATE);
  const [activeSubTab, setActiveSubTab] = useState(SubMode.APP);
  const [navigateBrowserUrl, setNavigateBrowserUrl] = useState("");
  const [navigateAppUrl, setNavigateAppUrl] = useState("");
  const [shareConnectionAppUrl, setShareConnectionAppUrl] = useState("");
  const [navigateCoreUrl, setNavigateCoreUrl] = useState("");
  const [shareConnectionCoreUrl, setShareConnectionCoreUrl] = useState("");
  const [navigateBrowserSrc, setNavigateBrowserSrc] = useState("");
  const [navigateAppSrc, setNavigateAppSrc] = useState("");
  const [shareConnectionSrc, setShareConnectionSrc] = useState("");
  const [urlCopied, setUrlCopied] = useState(false);
  let t1;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t1 = function generateSources(refreshToken, walletAddress, role) {
      let routerPath = pathname ?? "";
      if (routerPath.endsWith("/")) {
        routerPath = routerPath.slice(0, -1);
      }
      const searchParamsString = searchParams?.toString() ?? "";
      if (searchParamsString) {
        routerPath = routerPath + `?${searchParamsString}`;
      }
      const appScheme = publicEnv.MOBILE_APP_SCHEME ?? "mobile6529";
      const coreScheme = publicEnv.CORE_SCHEME ?? "core6529";
      const browserUrl = `${window.location.origin}${routerPath}`;
      const appUrl = `${appScheme}://${DeepLinkScope.NAVIGATE}${routerPath}`;
      const coreUrl = `${coreScheme}://${DeepLinkScope.NAVIGATE}${routerPath}`;
      setNavigateBrowserUrl(browserUrl);
      setNavigateAppUrl(appUrl);
      setNavigateCoreUrl(coreUrl);
      let shareConnectionAppUrl_0 = "";
      let shareConnectionCoreUrl_0;
      if (refreshToken && walletAddress) {
        shareConnectionAppUrl_0 = `${appScheme}://${DeepLinkScope.SHARE_CONNECTION}?token=${refreshToken}&address=${walletAddress}`;
        shareConnectionCoreUrl_0 = `${coreScheme}://${DeepLinkScope.NAVIGATE}/accept-connection-sharing?token=${refreshToken}&address=${walletAddress}`;
        if (role) {
          shareConnectionAppUrl_0 = shareConnectionAppUrl_0 + `&role=${role}`;
          shareConnectionCoreUrl_0 = shareConnectionCoreUrl_0 + `&role=${role}`;
        }
        setShareConnectionAppUrl(shareConnectionAppUrl_0);
        setShareConnectionCoreUrl(shareConnectionCoreUrl_0);
      } else {
        setShareConnectionSrc("");
      }
      QRCode.toDataURL(browserUrl, {
        width: 500,
        margin: 0
      }).then(dataUrl => {
        setNavigateBrowserSrc(dataUrl);
      });
      QRCode.toDataURL(appUrl, {
        width: 500,
        margin: 0
      }).then(dataUrl_0 => {
        setNavigateAppSrc(dataUrl_0);
      });
      if (shareConnectionAppUrl_0) {
        QRCode.toDataURL(shareConnectionAppUrl_0, {
          width: 500,
          margin: 0
        }).then(dataUrl_1 => {
          setShareConnectionSrc(dataUrl_1);
        });
      }
    };
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const generateSources = t1;
  let t2;
  if ($[3] !== generateSources || $[4] !== show) {
    t2 = () => {
      if (show) {
        generateSources(getRefreshToken(), getWalletAddress(), getWalletRole());
      }
    };
    $[3] = generateSources;
    $[4] = show;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== show) {
    t3 = [show];
    $[6] = show;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== isAuthenticated || $[9] !== show) {
    t4 = () => {
      setActiveTab(isAuthenticated ? Mode.SHARE : Mode.NAVIGATE);
      setActiveSubTab(SubMode.APP);
      if (show) {
        return;
      }
      const timer = setTimeout(() => {
        setNavigateBrowserSrc("");
        setNavigateAppSrc("");
        setShareConnectionSrc("");
      }, 150);
      return () => clearTimeout(timer);
    };
    $[8] = isAuthenticated;
    $[9] = show;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== show) {
    t5 = [show];
    $[11] = show;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== activeSubTab || $[14] !== activeTab || $[15] !== isMobile || $[16] !== navigateAppSrc || $[17] !== navigateAppUrl || $[18] !== navigateBrowserSrc || $[19] !== navigateBrowserUrl || $[20] !== navigateCoreUrl || $[21] !== shareConnectionAppUrl || $[22] !== shareConnectionCoreUrl || $[23] !== shareConnectionSrc || $[24] !== urlCopied) {
    t6 = function printImage() {
      const renderQRCodeImage = _temp;
      const renderCoreLink = _temp2;
      let content = null;
      let url_0 = "";
      if (activeTab === Mode.NAVIGATE) {
        bb69: switch (activeSubTab) {
          case SubMode.BROWSER:
            {
              url_0 = navigateBrowserUrl;
              content = renderQRCodeImage(navigateBrowserSrc, "Browser Link - QR Code");
              break bb69;
            }
          case SubMode.APP:
            {
              url_0 = navigateAppUrl;
              content = renderQRCodeImage(navigateAppSrc, "Mobile App Link - QR Code");
              break bb69;
            }
          case SubMode.CORE:
            {
              url_0 = navigateCoreUrl;
              content = renderCoreLink(navigateCoreUrl);
              break bb69;
            }
          default:
        }
      } else {
        if (activeTab === Mode.SHARE) {
          bb81: switch (activeSubTab) {
            case SubMode.APP:
              {
                url_0 = shareConnectionAppUrl;
                content = renderQRCodeImage(shareConnectionSrc, "Share Connection - QR Code");
                break bb81;
              }
            case SubMode.CORE:
              {
                content = renderCoreLink(shareConnectionCoreUrl);
                url_0 = shareConnectionCoreUrl;
                break bb81;
              }
            default:
              {
                content = <span>Invalid submode for SHARE</span>;
              }
          }
        } else {
          if (activeTab === Mode.APPS) {
            bb91: switch (activeSubTab) {
              case SubMode.APP:
                {
                  content = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-12 tw-p-10" style={squareStyle}><ShareMobileApp platform="ios" /><ShareMobileApp platform="android" /></div>;
                  break bb91;
                }
              case SubMode.CORE:
                {
                  content = <CoreAppsDownload />;
                }
            }
          }
        }
      }
      return <>{content}{url_0 && <div className="d-flex align-items-center gap-2 mt-2"><div className={styles.url}>{url_0}</div><FontAwesomeIcon icon={faCopy} className={`${styles.urlCopy} ${urlCopied ? styles.copied : ""}`} data-tooltip-id="copy-url-tooltip" onClick={() => {
            navigator.clipboard.writeText(url_0);
            setUrlCopied(true);
            setTimeout(() => setUrlCopied(false), 500);
          }} /><Tooltip id="copy-url-tooltip" place="top" content={urlCopied ? "Copied!" : "Copy URL"} openEvents={isMobile ? {
            click: true
          } : {
            mouseenter: true
          }} closeEvents={isMobile ? {
            click: true
          } : {
            mouseleave: true
          }} style={{
            backgroundColor: "#1F2937",
            color: "white",
            padding: "4px 8px"
          }} /></div>}</>;
    };
    $[13] = activeSubTab;
    $[14] = activeTab;
    $[15] = isMobile;
    $[16] = navigateAppSrc;
    $[17] = navigateAppUrl;
    $[18] = navigateBrowserSrc;
    $[19] = navigateBrowserUrl;
    $[20] = navigateCoreUrl;
    $[21] = shareConnectionAppUrl;
    $[22] = shareConnectionCoreUrl;
    $[23] = shareConnectionSrc;
    $[24] = urlCopied;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  const printImage = t6;
  let t7;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getRefreshToken();
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = (tab, subTab) => {
      setActiveTab(tab);
      setActiveSubTab(subTab);
    };
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== activeSubTab || $[29] !== activeTab) {
    t9 = <ModalMenu isShareConnection={!!t7} activeTab={activeTab} activeSubTab={activeSubTab} onTabChange={t8} />;
    $[28] = activeSubTab;
    $[29] = activeTab;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== printImage) {
    t10 = printImage();
    $[31] = printImage;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t9) {
    t11 = <Modal.Body className={styles.modalBody}>{t9}{t10}</Modal.Body>;
    $[33] = t10;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== onClose || $[37] !== show || $[38] !== t11) {
    t12 = <Modal show={show} onHide={onClose} keyboard={true} centered={true} data-testid="header-share-modal">{t11}</Modal>;
    $[36] = onClose;
    $[37] = show;
    $[38] = t11;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
}
function _temp2(url) {
  return <div className="tw-flex tw-items-center tw-gap-2" style={squareStyle}><a href={url} className="decoration-none tw-flex tw-flex-col tw-items-center tw-gap-8"><Image unoptimized={true} priority={true} loading="eager" src="/6529Core.png" alt="6529 Desktop" width={150} height={150} className="unselectable" /><Button variant="primary" className="tw-flex tw-w-full tw-items-center tw-gap-2"><FontAwesomeIcon icon={faExternalLink} /><div className="no-wrap">Open in 6529 Desktop</div></Button></a></div>;
}
function _temp(src, alt) {
  const defaultStyle = {
    maxWidth: "100%",
    height: "auto",
    border: "5px solid #fff"
  };
  return <Image unoptimized={true} priority={true} loading="eager" src={src} alt={alt} width={1000} height={1000} className="unselectable" style={{
    ...defaultStyle
  }} />;
}
function ModalMenu(t0) {
  const $ = _c(43);
  const {
    isShareConnection,
    activeTab,
    activeSubTab,
    onTabChange
  } = t0;
  const isElectron = useElectron();
  let t1;
  if ($[0] !== activeTab || $[1] !== isShareConnection || $[2] !== onTabChange) {
    t1 = isShareConnection && <Button className={activeTab === Mode.SHARE ? styles.disabledMenuBtn : ""} variant={activeTab === Mode.SHARE ? "light" : "outline-light"} onClick={() => onTabChange(Mode.SHARE, SubMode.APP)}>Share Connection</Button>;
    $[0] = activeTab;
    $[1] = isShareConnection;
    $[2] = onTabChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = activeTab === Mode.NAVIGATE ? styles.disabledMenuBtn : "";
  const t3 = activeTab === Mode.NAVIGATE ? "light" : "outline-light";
  let t4;
  if ($[4] !== onTabChange) {
    t4 = () => onTabChange(Mode.NAVIGATE, SubMode.APP);
    $[4] = onTabChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <Button className={t2} variant={t3} onClick={t4}>Current URL</Button>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = activeTab === Mode.APPS ? styles.disabledMenuBtn : "";
  const t7 = activeTab === Mode.APPS ? "light" : "outline-light";
  let t8;
  if ($[10] !== onTabChange) {
    t8 = () => onTabChange(Mode.APPS, SubMode.APP);
    $[10] = onTabChange;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = <Button className={t6} variant={t7} onClick={t8}>6529 Apps</Button>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t5 || $[18] !== t9) {
    t10 = <div className="d-flex gap-2">{t1}{t5}{t9}</div>;
    $[16] = t1;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = activeSubTab === SubMode.APP ? "light" : "outline-light";
  let t12;
  if ($[20] !== activeTab || $[21] !== onTabChange) {
    t12 = () => onTabChange(activeTab, SubMode.APP);
    $[20] = activeTab;
    $[21] = onTabChange;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="font-smaller">6529 Mobile</span>;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t12) {
    t14 = <Button variant={t11} onClick={t12}>{t13}</Button>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== activeSubTab || $[28] !== activeTab || $[29] !== onTabChange) {
    t15 = activeTab === Mode.NAVIGATE && <Button variant={activeSubTab === SubMode.BROWSER ? "light" : "outline-light"} onClick={() => onTabChange(activeTab, SubMode.BROWSER)}><span className="font-smaller">Browser</span></Button>;
    $[27] = activeSubTab;
    $[28] = activeTab;
    $[29] = onTabChange;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== activeSubTab || $[32] !== activeTab || $[33] !== isElectron || $[34] !== onTabChange) {
    t16 = !isElectron && <Button variant={activeSubTab === SubMode.CORE ? "light" : "outline-light"} onClick={() => onTabChange(activeTab, SubMode.CORE)}><span className="font-smaller">6529 Desktop</span></Button>;
    $[31] = activeSubTab;
    $[32] = activeTab;
    $[33] = isElectron;
    $[34] = onTabChange;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t15 || $[38] !== t16) {
    t17 = <div className="mt-3 d-flex gap-2">{t14}{t15}{t16}</div>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t10 || $[41] !== t17) {
    t18 = <div className="pt-2 pb-3 d-flex flex-column">{t10}{t17}</div>;
    $[40] = t10;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
}
function CoreAppsDownload() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      name: "windows",
      url: "https://6529bucket.s3.eu-west-1.amazonaws.com/6529-core-app/win/latest.yml",
      displayName: "Windows",
      downloadPath: "6529-core-app/win/links",
      image: "/windows.png",
      enabled: true
    }, {
      name: "mac",
      url: "https://6529bucket.s3.eu-west-1.amazonaws.com/6529-core-app/mac/latest-mac.yml",
      displayName: "macOS",
      downloadPath: "6529-core-app/mac/links",
      image: "/macos.png",
      enabled: true
    }, {
      name: "linux",
      url: "https://6529bucket.s3.eu-west-1.amazonaws.com/6529-core-app/linux/latest-linux.yml",
      displayName: "Linux",
      downloadPath: "6529-core-app/linux/links",
      image: "/linux.png",
      enabled: true
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const osConfigs = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [versions, setVersions] = useState(t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const fetchYml = _temp3;
      const loadVersions = async () => {
        const versions_0 = [];
        for (const osConfig of osConfigs.filter(_temp4)) {
          ;
          try {
            const ymlData = await fetchYml(osConfig.url);
            versions_0.push({
              ...osConfig,
              version: ymlData.version
            });
          } catch (t4) {
            const error = t4;
            console.error(`Failed to fetch or process ${osConfig.displayName}:`, error);
          }
        }
        setVersions(versions_0);
      };
      loadVersions();
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== versions) {
    t4 = versions.map(_temp5);
    $[4] = versions;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div style={squareStyle}><div className="tw-inline-flex tw-flex-col tw-gap-10">{t4}</div></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp5(version) {
  return <CoreAppDownload key={version.name} platform={version.displayName} icon={version.image} title={version.displayName} downloadPath={version.downloadPath} version={version.version ?? ""} />;
}
function _temp4(config) {
  return config.enabled;
}
async function _temp3(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}`);
  }
  const text = await response.text();
  return yaml.load(text) as LatestYml;
}
function CoreAppDownload(t0) {
  const $ = _c(10);
  const {
    platform,
    icon,
    title,
    downloadPath,
    version
  } = t0;
  if (!version) {
    return null;
  }
  const url = `https://d3lqz0a4bldqgf.cloudfront.net/${downloadPath}/${version}.html`;
  let t1;
  if ($[0] !== icon || $[1] !== title) {
    t1 = <div className="tw-rounded-full tw-bg-white tw-p-4"><Image unoptimized={true} priority={true} loading="eager" src={icon} alt={title} width={40} height={40} className="unselectable" /></div>;
    $[0] = icon;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== platform || $[4] !== version) {
    t2 = <div className="tw-flex tw-w-full tw-items-center tw-gap-2"><div className="no-wrap tw-text-lg tw-font-semibold">{platform} v{version}</div></div>;
    $[3] = platform;
    $[4] = version;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== url) {
    t3 = <a href={url} target="_blank" rel="noopener noreferrer" className="decoration-none tw-flex tw-w-full tw-items-center tw-gap-4 tw-rounded-lg tw-border tw-border-solid tw-border-white tw-bg-black tw-px-5 tw-py-3 tw-transition-all tw-duration-300 tw-ease-out hover:tw-scale-[1.03]">{t1}{t2}</a>;
    $[6] = t1;
    $[7] = t2;
    $[8] = url;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}